class Validate {
  constructor(erros = []) {
    this.erros = erros;
  }

  addMensagem(mensagem) {
    if (!this.erros.find(err => err === mensagem)) {
      this.erros.push({ mensagem });
    }

    return this;
  }

  addSeNuloOuVazio(campo, valor) {
    if (campo) {
      if (!Array.isArray(valor)) {
        if (valor === null || valor === "") this.erros.push({ mensagem: campo, chave: true });
      } else if (valor === [] || valor.length === 0) {
        this.erros.push({ mensagem: campo, chave: true });
      }
    } else {
      console.log("A chave não pode ser nula.");
    }

    return this;
  }

  addSeMenorIgualZero(nome, valor) {
    if (nome) {
      if (Number.isInteger(valor) && valor <= 0) {
        this.erros.push({ mensagem: nome, chave: true });
      } else if (valor === null || valor === "") {
        this.erros.push({ mensagem: nome, chave: true });
      }
    } else {
      console.log("A chave não pode ser nula.");
    }

    return this;
  }

  build() {
    return this.erros.map((erro) => {
      if (erro.chave) {
        return `O campo '${erro.mensagem}' deve ser preenchido!`;
      }

      return erro.mensagem;
    });
  }
}

export const validarCamposObrigatorios = () => new Validate();

export const isNuloOuVazio = (valor) => {
  if (!Array.isArray(valor) && (valor === null || valor === "" || valor === undefined)) {
    return true;
  } else if (valor === [] || valor.length === 0) {
    return true;
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/utils/Validate.js